// extracted by mini-css-extract-plugin
module.exports = {"MerchantAccess":"MerchantAccess_MerchantAccess__3nB6U"};